export default "__VITE_ASSET__BbjOFMSR__"